import styled from "styled-components";

export const List = styled.ul`
    padding-bottom: 1rem;`;
